/**
 * Format a date string or Date object into a readable format
 * @param {string|Date} date - The date to format
 * @param {object} options - Additional formatting options
 * @returns {string} Formatted date string
 */
export const formatDate = (date, options = {}) => {
  if (!date) return 'N/A';
  
  const dateObj = new Date(date);
  
  // Default options
  const defaultOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...options
  };
  
  // Check if we should show time
  if (options.timeOnly === true) {
    return new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    }).format(dateObj);
  }
  
  // Check if we should hide time
  if (options.dateOnly === true) {
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(dateObj);
  }
  
  // Default full format
  return new Intl.DateTimeFormat('en-US', defaultOptions).format(dateObj);
};
